// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circleMinus16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle-minus': IconCircleMinus;
    }
}

/**
 * The icon component for the 'circleMinus' icon
 */
export class IconCircleMinus extends Icon {
    public constructor() {
        super(circleMinus16X16);
    }
}

registerIcon('icon-circle-minus', IconCircleMinus);
export const iconCircleMinusTag = 'nimble-icon-circle-minus';
